/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

import type { SpecificEventListener } from "@/types";
import { getComponentElements } from "@/utils/dom/component";

export function initLimiter() {
    getComponentElements<HTMLSelectElement>(Limiter.selector).forEach(element => new Limiter(element));
}

export class Limiter {
    static readonly selector = 'limiter';

    public element: HTMLSelectElement;

    private changeListener: SpecificEventListener<'change'>;

    constructor(element: HTMLSelectElement) {
        this.element = element;

        this.changeListener = () => {
            const url = this.element.options[this.element.selectedIndex].value;
            if (url) {
                location.href = url;
            }
        };
        this.element.addEventListener('change', this.changeListener);
    }

    /**
     * Destroy instance
     */
    public destroy(): void {
        this.element.removeEventListener('change', this.changeListener);
    }
}
